declare global {
  interface Window {
    gtag?: (...args: any[]) => void
    dataLayer?: any[]
  }
}

const GA_FIELD_TIMEOUT_MS = 1500

type GAField = 'client_id' | 'session_id'

// Os ids do GA4 sao estaveis durante a navegacao, entao resolvemos uma vez e
// reaproveitamos. Sem isso o interceptor do axios pagava o custo do gtag('get')
// em toda requisicao.
const cache: Partial<Record<GAField, string | null>> = {}
const pending: Partial<Record<GAField, Promise<string | null>>> = {}

const readGAField = (field: GAField): Promise<string | null> => {
  return new Promise((resolve) => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
      resolve(null)
      return
    }

    let settled = false
    const settle = (value: string | null) => {
      if (settled) return
      settled = true
      resolve(value)
    }

    // O gtag('get') nao chama o callback quando o consentimento ainda nega
    // analytics_storage, entao o timeout e o que garante que a Promise resolve.
    const timeoutId = setTimeout(() => settle(null), GA_FIELD_TIMEOUT_MS)

    try {
      window.gtag('get', import.meta.env.VITE_GA4_MEASUREMENT_ID, field, (value: string) => {
        clearTimeout(timeoutId)
        settle(value || null)
      })
    } catch (error) {
      clearTimeout(timeoutId)
      settle(null)
    }
  })
}

const getGAField = (field: GAField): Promise<string | null> => {
  const cached = cache[field]
  if (cached) {
    return Promise.resolve(cached)
  }

  const inFlight = pending[field]
  if (inFlight) {
    return inFlight
  }

  const request = readGAField(field).then((value) => {
    delete pending[field]

    // Só guarda valor resolvido: null pode ser apenas "gtag ainda nao carregou"
    // ou "consentimento ainda nao concedido", e deve ser tentado de novo depois.
    if (value) {
      cache[field] = value
    }

    return value
  })

  pending[field] = request

  return request
}

export const getGAClientId = (): Promise<string | null> => getGAField('client_id')

export const getGASessionId = (): Promise<string | null> => getGAField('session_id')
